
export let globalSocket = null;
export let disconnectTimeoutRef = null;
export let reconnectTimeoutRef = null;
export let reconnectAttempts = 0;
export let isIntentionallyDisconnected = false;
export let activeChatId = null;
export let pingIntervalRef = null;


export const TAB_ID = Math.random().toString(36).substring(2, 11);
export const socketChannel = new BroadcastChannel('whatsapp_socket_sync');
export let isLeader = false;
export let leaderElectionTimeout = null;

export const setGlobalSocket = (socket) => { globalSocket = socket; };
export const setIntentionallyDisconnected = (val) => { isIntentionallyDisconnected = val; };
export const setReconnectAttempts = (val) => { reconnectAttempts = val; };
export const incrementReconnectAttempts = () => { reconnectAttempts += 1; };
export const setReconnectTimeoutRef = (ref) => { reconnectTimeoutRef = ref; };
export const setDisconnectTimeoutRef = (ref) => { disconnectTimeoutRef = ref; };
export const setIsLeader = (val) => { isLeader = val; };
export const setLeaderElectionTimeout = (timeout) => { leaderElectionTimeout = timeout; };
export const setPingIntervalRef = (ref) => { pingIntervalRef = ref; };
export const setActiveChatId = (id) => { activeChatId = id; };

export const disconnectWhatsAppSocket = () => {
  isIntentionallyDisconnected = true;
  if (reconnectTimeoutRef) {
    clearTimeout(reconnectTimeoutRef);
    reconnectTimeoutRef = null;
  }
  if (disconnectTimeoutRef) {
    clearTimeout(disconnectTimeoutRef);
    disconnectTimeoutRef = null;
  }
  if (pingIntervalRef) {
    clearInterval(pingIntervalRef);
    pingIntervalRef = null;
  }
  if (globalSocket) {
    globalSocket.close();
    globalSocket = null;
  }
};

export const isWebSocketConnected = () => {
  return globalSocket?.readyState === WebSocket.OPEN;
};

export const sendMessageViaWebSocket = (conversationId, contentType, contentData) => {
  return new Promise((resolve) => {
    if (!globalSocket || globalSocket.readyState !== WebSocket.OPEN) {
      resolve(false);
      return;
    }

    try {
      const messagePayload = {
        action: 'SEND_MESSAGE',
        operation: 'SEND_MESSAGE',
        payload: {
          conversationId,
          contentType,
          contentData,
          timestamp: Date.now(),
        },
      };

      globalSocket.send(JSON.stringify(messagePayload));
      resolve(true);
    } catch (error) {
      resolve(false);
    }
  });
};
